module.exports = __webpack_public_path__ + "static/sun-3de4f96423544d395fbdcfc198cc1dbd.png";